import { render, staticRenderFns } from "./BizInsuranceWithTypeModal.vue?vue&type=template&id=eedd87a4&"
import script from "./BizInsuranceWithTypeModal.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceWithTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports